const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['oneplace-authentication'] = require('../middleware/oneplace-authentication.js')
middleware['oneplace-authentication'] = middleware['oneplace-authentication'].default || middleware['oneplace-authentication']

export default middleware
